import { Component, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonCol, IonRow, IonText } from '@ionic/angular/standalone';
import { PuzzleWinDialogInjectableInterface } from '../../shared-module/puzzle-win-dialog/puzzle-win-dialog-injectable.interface';
import { Subscription } from 'rxjs';
import { Store } from '@ngxs/store';
import { PuzzleGameState } from '../../store/puzzle-game.state';
import { map } from 'rxjs/operators';
import { PuzzleGameModel } from '../../store/puzzle-game.model';
import { PuzzleTimeRecordState } from '../../store/puzzle-time-record.state';
import { PuzzleTimeRecordModel } from '../../store/puzzle-time-record.model';
import { PuzzleFrameworkService } from '../../puzzle-framework-module/puzzle-framework.service';
import { PuzzleWinDialogService } from '../../shared-module/puzzle-win-dialog/puzzle-win-dialog.service';
import { TranslateService } from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';
import { PuzzleSolutionWordAnimationComponent } from 'projects/tools/src/lib/shared-module/puzzle-solution-word-animation/puzzle-solution-word-animation.component';

@Component({
  selector: 'lib-app-swedish-win-screen',
  templateUrl: './crossword-win-screen.component.html',
  styleUrls: ['./crossword-win-screen.component.scss'],
  standalone: true,
  imports: [CommonModule, IonCol, IonRow, IonText, PuzzleSolutionWordAnimationComponent, TranslateModule],
})
export class CrosswordWinScreenComponent implements PuzzleWinDialogInjectableInterface, OnDestroy {
  private puzzleGameSubscription: Subscription;
  private timeRecordSubscription: Subscription;
  private puzzleIDSubscription: Subscription;
  // private swedishGameSubscription: Subscription;

  public data: {
    solutionWord: string;
    solutionOriginal: string;
    sayingText: string;
    sayingOriginal: string;
  };

  public translationKey: string;

  public moveCounter: number;
  public duration: string;
  public solutionWord: string;
  public solutionOriginal: string;

  constructor(
    private store: Store,
    private framework: PuzzleFrameworkService,
    private winDialogService: PuzzleWinDialogService,
    private translateService: TranslateService
  ) {
    this.puzzleIDSubscription = this.store
      .select((state) => state.puzzleID)
      .subscribe((puzzleID) => {
        this.puzzleGameSubscription = this.store
          .select(PuzzleGameState.getByID(puzzleID))
          .subscribe((puzzleGame: PuzzleGameModel) => {
            this.moveCounter = puzzleGame.moveCounter;
          });
        this.timeRecordSubscription = this.store
          .select(PuzzleTimeRecordState.getTimeRecordByID)
          .pipe(map((filterFn) => filterFn(puzzleID)))
          .subscribe((timeRecord: PuzzleTimeRecordModel) => {
            this.duration = timeRecord.timeRecord.timeString;
          });
      });

    this.translationKey = this.framework.getTranslationKey();
    this.translateService
      .get(this.translationKey + '.win_dialog.title')
      .toPromise()
      .then((title) => {
        this.winDialogService.setTitle(title);
      });
  }

  setData(data: any): void {
    this.data = data;
  }

  ngOnDestroy() {
    if (this.puzzleIDSubscription) {
      this.puzzleIDSubscription.unsubscribe();
    }
  }
}
